var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPersonRemoved = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 4.5C13.7143 2.01375 11.6686 0 9.14286 0C6.61714 0 4.57143 2.01375 4.57143 4.5C4.57143 6.98625 6.61714 9 9.14286 9C11.6686 9 13.7143 6.98625 13.7143 4.5ZM17.1429 6.75V9H24V6.75H17.1429ZM0 15.75V18H18.2857V15.75C18.2857 12.7575 12.1943 11.25 9.14286 11.25C6.09143 11.25 0 12.7575 0 15.75Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPersonRemoved, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PersonRemoved.52a50ab3.svg";
export { ForwardRef as ReactComponent };